<template>
  <div class="con-config-int">
    <RF-Status v-if="statusGeral !== ''" :cpntStatus="statusGeral" :cpntIcone="false" :cpntTamanho="5"></RF-Status>

    <template v-else-if="Object.keys(formulario).length >= 1 && Object.keys(formulario.field).length >= 1">
      <div>
        <RF-Select2 v-if="formulario.field.hasOwnProperty('integracao')"
          :data-time="time" :class='"rf-field-tamanho-" + (formulario.field.integracao.hasOwnProperty("tamanho") ? formulario.field.integracao.tamanho : 0)'

          :cpntStatus='formulario.field.integracao.status'
          :cpntId='formulario.field.integracao.id'
          :cpntClassDivField='formulario.field.integracao.classDivField'
          :cpntNome='formulario.field.integracao.nome'
          :cpntValue='formulario.field.integracao.value'
          :cpntOptions='formulario.field.integracao.options'
          :cpntKeyValue='formulario.field.integracao.keyValue'
          :cpntKeyMostra='formulario.field.integracao.keyMostra'
          :cpntAutoComplete='formulario.field.integracao.autocomplete'
          :cpntDisabled='formulario.field.integracao.disabled'
          :cpntMostrar='formulario.field.integracao.mostrar'
          :cpntMensagem='formulario.field.integracao.mensagem'
          :cpntOptionInicialNome='formulario.field.integracao.optionInicialNome'
          :cpntOptionInicialValue='formulario.field.integracao.optionInicialValue'
          :cpntMensagemTipo='formulario.field.integracao.mensagemTipo'
          :cpntAddOption='formulario.field.integracao.addOption'
          :cpntMultiple='formulario.field.integracao.multiple'
          :cpntExplica='formulario.field.integracao.explica'
          :cpntClassSelect='formulario.field.integracao.classSelect2'
          :cpntTabIndex='formulario.field.integracao.tabIndex'

          :cpntOnKeyPressEnter='formulario.field.integracao.onKeyPressEnter'
          :cpntOnChange='formulario.field.integracao.onChange'
          :cpntOnBlur='formulario.field.integracao.onBlur'
          :ref='formulario.field.integracao.tipo'
        ></RF-Select2>

        <RF-Select2 v-if="formulario.field.hasOwnProperty('parceiro')"
          :data-time="time" :class='"rf-field-tamanho-" + (formulario.field.parceiro.hasOwnProperty("tamanho") ? formulario.field.parceiro.tamanho : 0)'

          :cpntStatus='formulario.field.parceiro.status'
          :cpntId='formulario.field.parceiro.id'
          :cpntClassDivField='formulario.field.parceiro.classDivField'
          :cpntNome='formulario.field.parceiro.nome'
          :cpntValue='formulario.field.parceiro.value'
          :cpntOptions='formulario.field.parceiro.options'
          :cpntKeyValue='formulario.field.parceiro.keyValue'
          :cpntKeyMostra='formulario.field.parceiro.keyMostra'
          :cpntAutoComplete='formulario.field.parceiro.autocomplete'
          :cpntDisabled='formulario.field.parceiro.disabled'
          :cpntMostrar='formulario.field.parceiro.mostrar'
          :cpntMensagem='formulario.field.parceiro.mensagem'
          :cpntOptionInicialNome='formulario.field.parceiro.optionInicialNome'
          :cpntOptionInicialValue='formulario.field.parceiro.optionInicialValue'
          :cpntMensagemTipo='formulario.field.parceiro.mensagemTipo'
          :cpntAddOption='formulario.field.parceiro.addOption'
          :cpntMultiple='formulario.field.parceiro.multiple'
          :cpntExplica='formulario.field.parceiro.explica'
          :cpntClassSelect='formulario.field.parceiro.classSelect2'
          :cpntTabIndex='formulario.field.parceiro.tabIndex'

          :cpntOnKeyPressEnter='formulario.field.parceiro.onKeyPressEnter'
          :cpntOnChange='formulario.field.parceiro.onChange'
          :cpntOnBlur='formulario.field.parceiro.onBlur'
          :ref='formulario.field.parceiro.tipo'
        ></RF-Select2>
      </div>

      <div style="width: 100%; text-align: center; margin: 8px 0px; height: 34px;">
        <RF-Button v-for='(button, index) in formulario.buttons' style="margin: 0px 5px;"
          :key="index"
          :data-time='time'

          :cpntStatus='button.status' 
          :cpntId='button.id' 
          :cpntTexto='button.texto' 
          :cpntClass='button.class'
          :cpntMostrar='button.mostrar'
          :cpntTabIndex='button.tabIndex'

          @onClickButton='button.onClick'
        ></RF-Button>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .con-config-int {
    padding: 30px 20px 20px 20px !important;

    min-width: 500px;
    min-height: 200px;
  }
    .con-config-int > div > div {
      display: block;
    }
</style>

<script>
  export default {
    components: {
      'RF-Select2': () => import('@/components/rf-geral/select2/RF-Select2.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        config: {},
        formulario: {}
      }
    },
    mounted: function () {
      this.conectorConfigIntegracaoIniciar()
    },
    methods: {
      conectorConfigIntegracaoIniciar: function () {
        var self = this

        // SETA O STATUS CARREGANDO DA PAGINA
        self.conectorConfigIntegracaoStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES DA INTEGRAÇÃO
        self.$store.state.GET_VALUE_LOCAL_STORAGE('CONECTOR', function (config) {
          // SETA O VALOR RECEBIDO
          self.config = config

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
          self.conectorConfigIntegracaoFormularioIniciar()
        }, process.env.VUE_APP_CRI_KEY)
      },
      conectorConfigIntegracaoFormularioIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: 'carregando',
          id: 'conector-config-form',
          field: {},
          tabIndexFieldGeral: 101,
          tabIndexButtonGeral: 102
        }

        self.formulario.field.integracao = {
          tipo: 'select2',
          tamanho: 1,
          id: self.formulario.id + '-' + 'integracao',
          nome: 'Integração',
          keyValue: 'id',
          keyMostra: [ 'id', ' - ', 'nome' ],
          options: [],
          optionInicialNome: 'Selecione',
          onChange: self.conectorConfigIntegracaoOnChange
        }

        self.formulario.field.parceiro = {
          tipo: 'select2',
          tamanho: 1,
          id: self.formulario.id + '-' + 'parceiro',
          nome: 'Parceiro',
          keyValue: 'id',
          keyMostra: [ 'id', ' - ', 'nome' ],
          options: [],
          onChange: self.conectorConfigIntegracaoOnChange
        }

        // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS VALORES RECEBIDOS
          self.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CRIA OS BOTÕES
          self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, [ 0 ], null, {
            env: self.conectorConfigIntegracaoSalvar
            // can: self.conectorConfigIntegracaoIniciar
          }, function (buttons) {
            buttons.env.texto = 'Salvar'

            // SETA OS BUTTONS RECEBIDOS
            self.formulario.buttons = buttons

            // CHAMA A FUNÇÃO PARA BUSCAR OS OPTIONS DE INTEGRAÇÃO
            self.conectorConfigIntegracaoBuscarIntegracao(true)
          })
        })
      },
      conectorConfigIntegracaoOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.substring((this.formulario.id.length + 1), id.length)

        // SETA O VALOR ATUALIZADO RECEBIDO
        this.formulario.field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index) {
          case 'integracao':
            this.conectorConfigIntegracaoBuscarParceiros()
            break
        }
      },
      conectorConfigIntegracaoBuscarIntegracao: function (valorInicial = false) {
        var self = this

        // MONTA O QUERYGET QUE SERA FEITO NA API
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null } }

        self.$store.state.comunicaAPI('/integracao/get/', 'GET', queryGet, function (apiSuccess) {
          // SETA OS VALORES RECEBIDOS
          self.formulario.field.integracao.options = apiSuccess.data

          // SETA O VALOR INICIAL DO CAMPO
          if (valorInicial === true && Object.keys(self.config).length >= 1 && self.config.hasOwnProperty('integracao')) {
            self.formulario.field.integracao.value = self.config.integracao.id
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA BUSCAR OS OPTIONS DE PARCEIROS
          self.conectorConfigIntegracaoBuscarParceiros(valorInicial)
        }, self.conectorConfigIntegracaoStatusGeral)
      },
      conectorConfigIntegracaoBuscarParceiros: function (valorInicial = false) {
        var self = this

        if (self.formulario.field.integracao.value !== '') {
          // SETA O OPTIONS INICIAL DO SELECT
          self.formulario.field.parceiro.optionInicialNome = 'Selecione'

          // ATIVA O CAMPO
          self.formulario.field.parceiro.disabled = false

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          self.$store.state.comunicaAPI('/integracao/parceiro/', 'GET', self.formulario.field.integracao.value, function (apiSuccess) {
            // SETA OS VALORES RECEBIDOS
            self.formulario.field.parceiro.options = apiSuccess.data

            // SETA O VALOR INICIAL DO CAMPO
            if (valorInicial === true && Object.keys(self.config).length >= 1 && self.config.hasOwnProperty('parceiro')) {
              self.formulario.field.parceiro.value = self.config.parceiro.id
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            if (valorInicial === true) {
              // SETA O STATUS CARREGANDO DA PAGINA
              self.conectorConfigIntegracaoStatusGeral('')
            }
          }, self.conectorConfigIntegracaoStatusGeral)
        } else {
          // SETA O OPTIONS INICIAL DO SELECT
          self.formulario.field.parceiro.optionInicialNome = 'Selecione uma integração antes de prosseguir.'

          // LIMPA TODOS OS OPTIONS
          self.formulario.field.parceiro.options = []

          // DESATIVA O CAMPO
          self.formulario.field.parceiro.disabled = true

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          if (valorInicial === true) {
            // SETA O STATUS CARREGANDO DA PAGINA
            self.conectorConfigIntegracaoStatusGeral('')
          }
        }
      },
      conectorConfigIntegracaoStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      conectorConfigIntegracaoSalvar: function () {
        var self = this

        // INICIA A VARIAVEL SE PASSOU NA VALIDAÇÃO OU NÃO
        var passou = true

        // COLOCA O STATUS DE CARREGANDO PARA O BUTTON
        self.formulario.buttons.env.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // VERIFICA O CAMPO INTEGRAÇÃO
        if (self.formulario.field.integracao.value === '') {
          self.formulario.field.integracao.mensagem = 'É necessário selecionar a integração antes de continuar.'
          self.formulario.field.integracao.mensagemTipo = 'error'
          passou = false
        }

        if (self.formulario.field.parceiro.value === '') {
          self.formulario.field.parceiro.mensagem = 'É necessário selecionar o parceiro antes de continuar.'
          self.formulario.field.parceiro.mensagemTipo = 'error'
          passou = false
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        if (passou === true) {
          // SETA O CODIGO DA LICENÇA DE USO CONFIGURADA
          self.config.clu = self.$store.state.token.clu

          // PEGA OS DADOS DA INTEGRAÇÃO SALVO
          self.config.integracao = self.formulario.field.integracao.options.filter(item => item.id === self.formulario.field.integracao.value)[0]

          // PEGA OS DADOS DO PARCEIRO SALVO
          self.config.parceiro = self.formulario.field.parceiro.options.filter(item => item.id === self.formulario.field.parceiro.value)[0]

          // SALVA OS DADOS NO LOCAL STORAGE
          self.$store.state.SET_VALUE_LOCAL_STORAGE('CONECTOR', self.config, function () {
            // APRESENTA A MENSAGEM
            self.$store.state.msgWarn('WEB [200]: Configurações de integração salvas com sucesso.', 'success')

            // COLOCA O STATUS DE CARREGANDO PARA O BUTTON
            self.formulario.buttons.env.status = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }, process.env.VUE_APP_CRI_KEY)
        } else {
          // COLOCA O STATUS DE CARREGANDO PARA O BUTTON
          self.formulario.buttons.env.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        }
      }
    }
  }
</script>